<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';

import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    inboxName: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const buhotextChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName?.trim(),
            channel: {
              type: 'buhotext',
              // No enviamos device_id ni sim_subscription_id
              // Se configurarán después en la configuración del inbox
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_buhotext_device',
          params: {
            page: 'new',
            inbox_id: buhotextChannel.id,
          },
        });
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.ADD.BUHOTEXT.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <form
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="createChannel()"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.inboxName.$error }">
          {{ $t('INBOX_MGMT.ADD.BUHOTEXT.INBOX_NAME.LABEL') }}
          <input
            v-model="inboxName"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.BUHOTEXT.INBOX_NAME.PLACEHOLDER')
            "
            @blur="v$.inboxName.$touch"
          />
          <span v-if="v$.inboxName.$error" class="message">{{
            $t('INBOX_MGMT.ADD.BUHOTEXT.INBOX_NAME.ERROR')
          }}</span>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0 mt-4">
        <div class="p-4 bg-n-alpha-2 border border-n-weak rounded-lg">
          <p class="text-sm text-n-slate-11">
            {{ $t('INBOX_MGMT.ADD.BUHOTEXT.DEVICE_INFO.TITLE') }}
          </p>
          <p class="text-xs text-n-slate-10 mt-2">
            {{ $t('INBOX_MGMT.ADD.BUHOTEXT.DEVICE_INFO.DESCRIPTION') }}
          </p>
        </div>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.BUHOTEXT.SUBMIT_BUTTON')"
          :disabled="v$.$invalid"
        />
      </div>
    </form>
  </div>
</template>
